import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { CITY_OPTIONS } from "@/components/InquiryForm";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function WaitlistForm() {
  const [form, setForm] = useState({ name: "", phone: "", city: "", email: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e?.target ? e.target.value : e }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/waitlist`, form);
      toast.success("You're on the list! We'll notify you when our workspaces open.");
      setForm({ name: "", phone: "", city: "", email: "" });
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="mt-10 max-w-xl mx-auto" data-testid="waitlist-form">
      <div className="flex flex-col sm:flex-row gap-3">
        <Input data-testid="waitlist-name-input" placeholder="Your name" required
          className="h-14 rounded-full bg-white/95 border-0 text-slate-900 placeholder:text-slate-400 px-6"
          value={form.name} onChange={set("name")} />
        <Input data-testid="waitlist-phone-input" placeholder="Mobile / WhatsApp no." required
          className="h-14 rounded-full bg-white/95 border-0 text-slate-900 placeholder:text-slate-400 px-6"
          value={form.phone} onChange={set("phone")} />
        <Select value={form.city} onValueChange={set("city")}>
          <SelectTrigger data-testid="waitlist-city-select" className="h-14 rounded-full bg-white/95 border-0 text-slate-900 px-6 sm:w-44">
            <SelectValue placeholder="City" />
          </SelectTrigger>
          <SelectContent>
            {CITY_OPTIONS.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <Input data-testid="waitlist-email-input" type="email" placeholder="Email (optional — for launch announcement)"
        className="mt-3 h-14 rounded-full bg-white/95 border-0 text-slate-900 placeholder:text-slate-400 px-6"
        value={form.email} onChange={set("email")} />
      <Button type="submit" disabled={loading} data-testid="waitlist-submit-button"
        className="mt-4 w-full sm:w-auto rounded-full bg-white text-slate-900 hover:bg-white/90 px-10 h-14 font-semibold transition-transform duration-200 hover:-translate-y-0.5">
        {loading ? "Joining..." : "Notify Me"} {!loading && <ArrowRight className="ml-2 w-4 h-4" />}
      </Button>
      <p className="mt-3 text-xs text-white/60">No spam — one message when doors open.</p>
    </form>
  );
}
